<div
  [class.cardWithShadow]="!isStandaloneUserTab"
  [class.rounded]="!isStandaloneUserTab"
  [class.shadow-sm]="!isStandaloneUserTab"
  [class.p-16]="!isStandaloneUserTab">
  <app-data-table
    [tableId]="tableId"
    [tableConfig]="tableConfig"
    [params]="params"
    [topOptions]="topOptions"
    [keepAppliedSearch]="true"
    [onClickRow]="onClickRow"
    [fetchTableData]="fetchUsers"/>
</div>
